// extracted by mini-css-extract-plugin
module.exports = {"shopInfo":"style_shopInfo__3ewlU","icon":"style_icon__1bEOe","infoGroup":"style_infoGroup__2FxhF","infoBlock":"style_infoBlock__hofd6"};